import { Card, Skeleton, Tabs, Typography } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { encrypt, formatDate } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import { useNavigate } from "react-router-dom";
import { UserDeleteOutlined } from "@ant-design/icons";

const { TabPane } = Tabs;

const { Text } = Typography;

function CallResponseTime() {
    const navigate = useNavigate();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates, selectedHotels, kioskSelection } =
        useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [hotelTableData, setHotelTableData] = useState([]);
    const [staffTableData, setStaffTableData] = useState([]);
    const [hotelTotalRecords, setHotelTotalRecords] = useState(0);
    const [staffTotalRecords, setStaffTotalRecords] = useState(0);
    const hotel_ids = selectedHotels;
    const [activeTab, setActiveTab] = useState("hotel");

    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "avg_response_total_time",
    });

    const [formDataForHotel, setFormDataForHotel] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        call_type: kioskSelection,
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const [formDataForStaff, setFormDataForStaff] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        sorting: "1",
        sort_by: "",
        call_type: kioskSelection,
    });

    const {
        status: responseTimeStatus,
        data: responseTimeRes,
        refetch: getResponseTime,
    } = useQuery(
        "averageRespoonseTime",
        async () => {
            return await HTTP("/dashboard/getNewCallsAvgResponseTimeDetails", {
                ...formDataForHotel,
            });
        },
        {
            enabled: false,
        },
    );

    const {
        status: staffResponseTimeStatus,
        data: staffResponseTimeRes,
        refetch: getStaffResponseTime,
    } = useQuery(
        "averageStaffRespoonseTime",
        async () => {
            return await HTTP(
                "/dashboard/getNewCallsAvgResponseTimeStaffWise",
                {
                    ...formDataForStaff,
                },
            );
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        if (activeTab == "hotel") {
            setFormDataForHotel({
                ...formDataForHotel,
                hotel_ids,
                page: 0,
                all_selected: hotel_ids.length === 0 ? true : false,
                start_date: formatDate(start_date),
                end_date: formatDate(end_date),
            });
        } else {
            setFormDataForStaff({
                ...formDataForStaff,
                hotel_ids,
                page: 0,
                all_selected: hotel_ids.length === 0 ? true : false,
                start_date: formatDate(start_date),
                end_date: formatDate(end_date),
            });
        }
    }, [activeTab]);

    useEffect(() => {
        getResponseTime();
    }, []);

    useEffect(() => {
        getResponseTime();
    }, [formDataForHotel]);

    useEffect(() => {
        getStaffResponseTime();
    }, [formDataForStaff]);

    useEffect(() => {
        if (responseTimeStatus === "success") {
            const { data: tableData, total } = responseTimeRes;
            console.log("tableData", tableData);
            setHotelTableData(tableData);
            setHotelTotalRecords(total);
        }
    }, [responseTimeStatus, responseTimeRes]);

    useEffect(() => {
        if (staffResponseTimeStatus === "success") {
            const { data: tableData, total } = staffResponseTimeRes;
            console.log("tableData", tableData);
            setStaffTableData(tableData);
            setStaffTotalRecords(total);
        }
    }, [staffResponseTimeStatus, staffResponseTimeRes]);

    function handleTableChangeForHotel(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formDataForHotel.sorting;
            delete formDataForHotel.sort_by;
            updateSortedInfo({});
        }

        const newformDataForHotel = {
            ...formDataForHotel,
            ...others,
        };

        setFormDataForHotel(newformDataForHotel);
    }

    function handleTableChangeForStaff(pagination, _, sorter) {
        console.log("sorter", sorter);
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formDataForStaff.sorting;
            delete formDataForStaff.sort_by;
        }

        const newformDataForStaff = {
            ...formDataForStaff,
            ...others,
        };

        setFormDataForStaff(newformDataForStaff);
    }

    const hotelColumns = [
        {
            title: "Hotel",
            dataIndex: "hotel_name",
            key: "hotel_name",
            render: (value, record) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer" }}
                    onClick={() => {
                        navigate(
                            `/average_staff_reponse_time?id=${encrypt(
                                record.hotel_id.toString(),
                            ).replace("+", "plus")}`,
                        );
                    }}
                >
                    {value}
                </span>
            ),
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Average Response Time",
            dataIndex: "avg_response_total_time",
            key: "avg_response_total_time",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "avg_response_total_time"
                    ? sortedInfo.order
                    : null,
        },
    ];

    const staffColumns = [
        {
            title: "Staff",
            render: (_, record) => (
                <div style={{ display: "flex", alignItems: "baseline" }}>
                    <p className="margin-right-5">
                        {record?.first_name !== "" && record?.last_name !== ""
                            ? `${record.first_name} ${record.last_name}`
                            : "-"}
                    </p>
                    {record?.is_deleted ? (
                        <UserDeleteOutlined style={{ color: "#F43F5E" }} />
                    ) : (
                        ""
                    )}
                </div>
            ),
            dataIndex: "first_name",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "first_name" ? sortedInfo.order : null,
        },
        {
            title: "Average Response Time",
            dataIndex: "avg_response_total_time",
            key: "avg_response_total_time",
            render: (value) => (value !== "" ? value : "-"),
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "avg_response_total_time"
                    ? sortedInfo.order
                    : null,
        },
    ];

    useEffect(() => {
        const hotel_ids = selectedHotels;
        if (activeTab == "hotel") {
            setFormDataForHotel({
                ...formDataForHotel,
                hotel_ids,
                page: 0,
                all_selected: hotel_ids.length === 0 ? true : false,
            });
        } else {
            setFormDataForStaff({
                ...formDataForStaff,
                hotel_ids,
                page: 0,
                all_selected: hotel_ids.length === 0 ? true : false,
            });
        }
    }, [selectedHotels]);

    useEffect(() => {
        let [start_date, end_date] = selectedDates;
        start_date = formatDate(start_date);
        end_date = formatDate(end_date);
        if (activeTab == "hotel") {
            setFormDataForHotel({
                ...formDataForHotel,
                start_date,
                page: 0,
                end_date,
            });
        } else {
            setFormDataForStaff({
                ...formDataForStaff,
                start_date,
                page: 0,
                end_date,
            });
        }
    }, [selectedDates]);

    useEffect(() => {
        if (activeTab == "hotel") {
            setFormDataForHotel({
                ...formDataForHotel,
                call_type: kioskSelection,
            });
        } else {
            setFormDataForStaff({
                ...formDataForStaff,
                call_type: kioskSelection,
            });
        }
    }, [kioskSelection]);

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader />
                <Tabs
                    type="card"
                    destroyInactiveTabPane={true}
                    activeKey={activeTab}
                    onChange={(key) => {
                        setActiveTab(key);
                    }}
                >
                    <TabPane key="hotel" tab="Hotels">
                        {responseTimeStatus !== "loading" &&
                        responseTimeStatus !== "idle" ? (
                            <CustomTable
                                columns={hotelColumns}
                                tableData={hotelTableData}
                                noOfrecords={hotelTotalRecords}
                                currentPage={formDataForHotel.page + 1}
                                handleTableChange={handleTableChangeForHotel}
                                // className="likeDisLikeTable"
                                rowKey="id"
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 20, width: 40 }}
                            />
                        )}
                    </TabPane>
                    <TabPane key="staff" tab="Staffs">
                        {responseTimeStatus !== "loading" &&
                        responseTimeStatus !== "idle" ? (
                            <CustomTable
                                columns={staffColumns}
                                tableData={staffTableData}
                                noOfrecords={staffTotalRecords}
                                currentPage={formDataForStaff.page + 1}
                                handleTableChange={handleTableChangeForStaff}
                                // className="likeDisLikeTable"
                                rowKey="id"
                            />
                        ) : (
                            <Skeleton
                                active
                                title={false}
                                paragraph={{ rows: 20, width: 40 }}
                            />
                        )}
                    </TabPane>
                </Tabs>
            </Card>
        </>
    );
}

export { CallResponseTime };
